import { render } from "./ModalCompareGoalCollections.vue?vue&type=template&id=a17b8230"
import script from "./ModalCompareGoalCollections.vue?vue&type=script&lang=js"
export * from "./ModalCompareGoalCollections.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__